import request from '@/utils/request'

let Existing_inventoryApi = {

  /*现有库存列表*/
  list(data) {
    return request._post('/shop/plus.existing_inventory.Index/index', data);
},
/*添加现有库存*/
add(data) {
    return request._post('/shop/plus.existing_inventory.Index/add', data);
},
/*修改现有库存*/
edit(data) {
    return request._post('/shop/plus.existing_inventory.Index/edit', data);
},
editPart(data) {
    return request._post('/shop/plus.existing_inventory.Index/editPart', data);
},
/*删除现有库存*/
del(data) {
    return request._post('/shop/plus.existing_inventory.Index/del', data);
},
getCount(data) {
    return request._post('/shop/plus.existing_inventory.Index/getCount', data);
},
getStatis(data) {
    return request._post('/shop/plus.existing_inventory.Index/getStatis', data);
},
getStatist(data) {
    return request._post('/shop/plus.existing_inventory.Index/getStatist', data);
},
getSupply(data) {
    return request._post('/shop/plus.existing_inventory.Index/getSupply', data);
},
getWarehouseStats(data) {
    return request._post('/shop/plus.existing_inventory.Index/getWarehouseStats', data);
},
/*现有库存详情*/
detail(data) {
  return request._post('/shop/plus.existing_inventory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.existing_inventory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.existing_inventory.Setting/getSetting', data, errorback);
    },
}
export default Existing_inventoryApi;



// WEBPACK FOOTER //
// ./src/api/existing_inventory.js